import { schema } from 'normalizr'

export const relativeSchema = new schema.Entity('relatives')
